import { useEffect, useState } from "react";

/**
 * Tracks how many times loading has changed from true to false.
 * Initial zero, will increment every time the value becomes false. (so will become one if loading is initially false).
 * @param loading the current loading state
 * @returns loadCount the number of times the boolean has changed from true to false.
 */
export const useLoadCounter = (loading: boolean | undefined): number => {
  const [loadCount, setLoadCount] = useState<number>(0);

  useEffect(() => {
    if (!loading) {
      setLoadCount(prevState => prevState + 1);
    }
  }, [loading]);

  return loadCount;
};
